// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"RichTextVideo-module--videoWrapper--_za20","video":"RichTextVideo-module--video--QIxZS","instaVideo":"RichTextVideo-module--instaVideo--3DlKk"};